import React, { FC, useEffect } from 'react'

import { updateChannelEvents } from '@/actions'
import { GridBoxElem } from '@/containers/HomeGridPage/styles'
import { useInternalGridBoxNav } from '@/hooks/useInternalGridBoxNav'
import useStore from '@/store/useStore'
import { BroadcastProps } from '@/types/componentsPropsTypes'

import { BroadcastAside } from './BroadcastAside'
import { BroadcastMain } from './BroadcastMain'
import { Layout, LayoutGrid } from './styles'

export const Broadcast: FC<BroadcastProps> = ({
  channelsList,
  isClassicHome,
  isHomeGrid,
  columnIndex = 0,
  rowIndex = 0,
  isPopup = false,
  broadcastId,
  isMuted,
  focusIdPrefix = '',
  scrollToSection,
  search,
  isInactiveSectionGrid,
}) => {
  const focusId = focusIdPrefix + 'HomeElement_broadcast'
  const isAppHidden = useStore((state) => state.common.isAppHidden)
  const broadcasts = useStore((state) => state.common.broadcasts)
  const setActiveBroadcastChannel = useStore(
    (state) => state.common.setActiveBroadcastChannel,
  )
  const setBroadcastChannelList = useStore(
    (state) => state.common.setBroadcastChannelList,
  )

  const { activeChannel, channelList: channels } =
    broadcasts?.[broadcastId] || {}
  const { onArrowHandler } = useInternalGridBoxNav()

  useEffect(() => {
    if (!channelsList) {
      return
    }

    updateChannelEvents(isAppHidden, channelsList)
    setBroadcastChannelList(broadcastId, channelsList)

    return () => {
      setBroadcastChannelList(broadcastId, [])
    }
  }, [channelsList, isAppHidden])

  useEffect(() => {
    if (channels?.length) {
      const hasActiveChannel = Boolean(
        activeChannel &&
          channels.find((channel) => activeChannel.id === channel.id),
      )
      const canSetActiveChannel = Boolean(
        (!activeChannel || !hasActiveChannel) && channels?.length,
      )

      canSetActiveChannel && setActiveBroadcastChannel(broadcastId, channels[0])
    }
  }, [channels, activeChannel, broadcastId])

  return isClassicHome ? (
    <Layout focusId={focusId} defaultFocusChild={0}>
      <BroadcastMain
        isClassicHome
        isPopup={isPopup}
        broadcastId={broadcastId}
        isMuted={isMuted}
        scrollToSection={scrollToSection}
      />
      <BroadcastAside isClassicHome broadcastId={broadcastId} />
    </Layout>
  ) : isHomeGrid ? (
    <LayoutGrid>
      <GridBoxElem
        focusId={`box.${columnIndex}.${rowIndex}.2.2`}
        $width={2}
        $height={2}
        onArrow={(e: LRUDEvent) => onArrowHandler(e, 'gridNode')}
      >
        <BroadcastMain
          isPopup={isPopup}
          broadcastId={broadcastId}
          focusIdPrefix={focusIdPrefix}
          isMuted={isMuted}
        />
      </GridBoxElem>
      <GridBoxElem
        focusId={`box.${columnIndex + 2}.${rowIndex}.1.2`}
        $width={1}
        $height={2}
        onArrow={(e: LRUDEvent) => onArrowHandler(e, 'gridNode')}
      >
        <BroadcastAside
          broadcastId={broadcastId}
          focusIdPrefix={focusIdPrefix}
        />
      </GridBoxElem>
    </LayoutGrid>
  ) : (
    <LayoutGrid>
      <BroadcastMain
        isPopup={isPopup}
        broadcastId={broadcastId}
        focusIdPrefix={focusIdPrefix}
        isMuted={isMuted}
        scrollToSection={scrollToSection}
        search={search}
        isInactiveSectionGrid={isInactiveSectionGrid}
      />
      <BroadcastAside focusIdPrefix={focusIdPrefix} broadcastId={broadcastId} />
    </LayoutGrid>
  )
}

export default Broadcast
